import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
var ProfileService = /** @class */ (function () {
    function ProfileService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    ProfileService.prototype.getPopup = function (popupId) {
        var url = environment.apiBase + ("users/" + popupId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    ProfileService.prototype.updateProfileDetails = function (body) {
        var url = environment.apiBase + ("users/" + body.popupId);
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body.update, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return ProfileService;
}());
export { ProfileService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/profile.service.ts.pre-build-optimizer.js